import { Typography } from "@material-ui/core"
import React from "react"

export const ErrorPage = (props: { message: string }) => {
    return (
        <Typography variant={"subtitle1"} color={"error"}>{props.message}</Typography>
    )
}
